import React from 'react';
import { Row, Col } from 'antd';
import AboutTile from '../../AbouTile';
import { stripTags, domHtml } from '../../../utils/stripTags';
import SEO from '../../Seo';
import SkillProgress from './SkillProgress';
import SkillFancy from './SkillFancy';

const pageText = {
  paraOne: `I am a full stack software developer with three years of professional experience in building enterprise-level software solutions.`,
  paraTwo: ` I specialize in javascript. I have been primarily working on js stacks like Nodejs, react, react-native, openlayers, and angular. Taking about me as a person, I am a highly organized guy, a technophile, and I love the world of javascript. I would love to see myself working on the projects intending to solve the real world's pressing issues.`,
};
const AboutMe = () => {
  const description = `${pageText.paraOne} ${stripTags(pageText.paraTwo)}`;
  return (
    <>
      <div>
        <SEO
          title="About"
          description={description}
          path=""
          keywords={['Kaylin', 'Khanal', 'Kathmandu', 'FullStack developer', 'Javascript', 'ReactJS', 'Django', 'Gatsby']}
        />
        <h1 className="titleSeparate">About Me</h1>
        <p>
          {pageText.paraOne}
        </p>
        <p dangerouslySetInnerHTML={domHtml(pageText.paraTwo)} />
      </div>
      <SkillProgress />
      {/* <h1 className="titleSeparate">More about me</h1>
      <Row gutter={[10, 10]}>
        <Col xs={24} sm={24} md={12} lg={8}>
          <AboutTile
            img="js.png"
            height={60}
            alt="javascript"
            textH4="Favorite Language"
            textH3="JavaScript/Typescript"
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8}>
          <AboutTile
            img="rn.png"
            alt="javascript"
            textH4="Preferred JS framework/lib"
            textH3="React"
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8}>
          <AboutTile
            img="books.png"
            alt="graduation image"
            textH4="Hobbies"
            textH3="Playing/watching Football #coyg"
            height={60}
            width={60}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8}>
          <AboutTile
            img="instructor.png"
            alt="motorcycle image"
            textH4="Currently Learning"
            textH3="Deno/AWS"
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8}>
          <AboutTile
            img="tools.png"
            alt="web image"
            textH4="Preferred Design/Prototyping Tools"
            textH3="Adobe xd/ Framer"
            height={60}
            width={60}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8}>
          <AboutTile
            img="rn.png"
            alt="web image"
            textH4="What I am most proficient at"
            textH3="React/Angular"
            height={60}
            width={60}
          />
        </Col>

        <Col xs={24} sm={24} md={12} lg={8}>
          <AboutTile
            img="django.png"
            alt="motorcycle image"
            textH4="Preferred Backend"
            textH3="Nodejs/php"
          />
        </Col>

        <Col xs={24} sm={24} md={12} lg={8}>
          <AboutTile
            img="search.png"
            alt="meeting image"
            textH4="Dream Project"
            textH3="RnD intensive project aiming to solve the pressing issues"
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8}>
          <AboutTile
            img="platform.png"
            alt="graduation image"
            textH4="Language"
            textH3="English and Nepali"
            height={60}
            width={60}
          />
        </Col>
      </Row> */}
    </>
  );
};
export default AboutMe;
